import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './AsnUpdateFooter.module.css';
import { DATE_FORMAT, ASN_STATUS } from '../../constants';
import StatusCircle from '../StatusCircle/StatusCircle';

const AsnUpdateFooter = ({ asns, activeDate, countData }) => {
  const originalAsns = asns.filter(
    ({ date }) => date === activeDate?.format(DATE_FORMAT.ISO),
  );

  //all ASN_STATUS count should be considering carry forward asns or taking all data irrespective
  //of original production date

  const asnsInLinedOut = asns.filter(asn => asn.status === ASN_STATUS.LINED_OUT)
    .length;
  const asnsInLineup = asns.filter(
    asn => asn.status === ASN_STATUS.READY_FOR_DROP,
  ).length;
  const droppedAsns = asns.filter(asn => asn.status === ASN_STATUS.DROPPED)
    .length;

  const rolledAsns = asns.filter(asn => asn.status === ASN_STATUS.ROLLED_OUT)
    .length;

  return (
    <div className={styles.container}>
      <div className={styles.planCountDisplay} data-testid={'countLegends'}>
        <div>
            <span className={clsx(styles.countMetric, styles.number)}>
             {countData?.data?.plan ?? 0}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {asns ? asns.length : 0}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {countData?.data?.lineOut ?? 0}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {countData?.data?.lineup ?? 0}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {countData?.data?.dropped ?? 0}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {countData?.data?.rolledOut ?? 0}
          </span>
        </div>
        <hr />
        <div>
          <span className={clsx(styles.countMetric, styles.label)}>Original Plan</span>
          <span className={clsx(styles.countMetric, styles.label)}>Actual Plan</span>
          <span className={clsx(styles.countMetric, styles.label)}>
            Lined Out
          </span>
          <span className={clsx(styles.countMetric, styles.label)}>
            Line up
          </span>
          <span className={clsx(styles.countMetric, styles.label)}>
            Dropped
          </span>
          <span className={clsx(styles.countMetric, styles.label)}>
            Rolled out
          </span>
        </div>
      </div>
      <div className={styles.legend}>
        <div className={styles.legendFlex}>
          <div className={styles.greyArea}>
            <div
              className={styles.dropTimeLegend}
              data-testid={'sequence-adhere-legends'}
            >
              <div>
                <span className={clsx(styles.colorText, styles.greenText)}>
                  hh:mm
                </span>
                <span className={styles.infoText}>In Sequence</span>
              </div>
              <div>
                <span className={clsx(styles.colorText, styles.yellowText)}>
                  hh:mm
                </span>
                <span className={styles.infoText}>Out of sequence</span>
              </div>
              <div>
                <span className={clsx(styles.colorText, styles.redText)}>
                  -
                </span>
                <span className={styles.infoText}>Lineout</span>
              </div>
            </div>
            <div className={styles.borderLine}></div>
            <div
              className={styles.statusLegend}
              data-testid={'trans-state-legends'}
            >
              <div className={styles.statusLegendFlex}>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'dropped'}
                    color="yellow"
                  />
                  <span className={styles.statusInfoText}>Dropped</span>
                </div>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'linedOut'}
                    color="red"
                  />
                  <span className={styles.statusInfoText}>Lineout</span>
                </div>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'booked'}
                    color="green"
                  />
                  <span className={styles.statusInfoText}>
                    Booked/Rolled/Available
                  </span>
                </div>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'dispatched'}
                    color="blue"
                  />
                  <span className={styles.statusInfoText}>Dispatched</span>
                </div>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'Pending'}
                  />
                  <span className={styles.statusInfoText}>Pending</span>
                </div>
                <br />
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'readyForDrop'}
                    color="white"
                  />
                  <span className={styles.statusInfoText}>Ready for drop</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AsnUpdateFooter.propTypes = {
  asns: PropTypes.array,
  activeDate: PropTypes.objectOf(moment),
  countData: PropTypes.array,
};

export default AsnUpdateFooter;
